import React from 'react';
import { AnnouncementList } from './partials/AnnouncementList/AnnouncementList';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { PaginationItemWithPageLink } from '../../_lib/components/Pagination';
import { AnnouncementProps } from './Announcement.types';
import { Facets } from '../../types/Facets';
import ResultListSettings from '../../components/molecules/ResultListSettings/ResultListSettings';
import { FACETS } from '../../components/molecules/ResultListSettings/ResultListSettings.enums';

type AnnouncementsContext = {
  pageItems?: PaginationItemWithPageLink[];
  announcements: AnnouncementProps[];
  facets: Facets;
  resetAllFiltersUrl?: { url: string };
};

function AnnouncementsInbox({ announcements, pageItems, facets, resetAllFiltersUrl }: AnnouncementsContext) {
  return (
    <>
      <ResultListSettings
        facets={facets}
        wantedFacets={[FACETS.FQ_BOOKMARKS]}
        resetAllFiltersUrl={resetAllFiltersUrl}
      />
      <AnnouncementList announcements={announcements} pageItems={pageItems} />
    </>
  );
}

export const AnnouncementsInboxBlock = asFetchableBlock(AnnouncementsInbox, BlockType.allannouncementsinbox);
export type AnnouncementsInboxBlock = React.ComponentProps<typeof AnnouncementsInboxBlock>;
